export default "__VITE_ASSET__CwghnrKB__"